import { TApplicationState } from '../../types/redux';
import { selectUserData } from './selectUserData';

const beautifyPhoneNumber = (phone?: string): string => {
  if (!phone) {
    return '';
  }

  return phone.replace(/^\+7/, '');
};

export const selectUserPhone = (state: TApplicationState): string => {
  const data = selectUserData(state);

  if (!data) {
    return '';
  }

  const { phones } = data;

  if (!phones || phones.length === 0) {
    return '';
  }

  return beautifyPhoneNumber(phones[0].phone);
};
